import { Check, PlusCircle } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import {
  Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem, CommandSeparator,
} from "../ui/command";

// Multi-select filter button (shadcn Tasks-example style). `selected` is a Set of option values;
// `counts` maps value → number of rows, shown on the right of each option.
export default function FacetFilter({ title, options, selected, onChange, counts = {} }) {
  const toggle = (value) => {
    const next = new Set(selected);
    next.has(value) ? next.delete(value) : next.add(value);
    onChange(next);
  };
  const picked = options.filter(o => selected.has(o.value));

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="inline-flex items-center gap-1.5 h-8 px-2.5 text-xs font-medium rounded-lg border border-dashed border-zinc-300 bg-white text-zinc-700 hover:bg-zinc-50">
          <PlusCircle size={13} className="text-zinc-400" />
          {title}
          {picked.length > 0 && (
            <>
              <span className="mx-0.5 h-4 w-px bg-zinc-200" />
              {picked.length > 2 ? (
                <span className="px-1.5 rounded bg-zinc-100 text-[11px]">{picked.length} selected</span>
              ) : picked.map(o => (
                <span key={o.value} className="px-1.5 rounded bg-zinc-100 text-[11px]">{o.label}</span>
              ))}
            </>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-56 p-0">
        <Command>
          <CommandInput placeholder={title} />
          <CommandList>
            <CommandEmpty>No results.</CommandEmpty>
            <CommandGroup>
              {options.map(o => {
                const on = selected.has(o.value);
                const Icon = o.icon;
                return (
                  <CommandItem key={o.value} value={o.label} onSelect={() => toggle(o.value)}>
                    <span
                      className="mr-2 flex h-4 w-4 items-center justify-center rounded border"
                      style={on ? { background: "#18181b", borderColor: "#18181b", color: "#fff" } : { borderColor: "#d4d4d8" }}
                    >
                      {on && <Check size={11} />}
                    </span>
                    {Icon && <Icon size={13} className="mr-2" style={{ color: o.color }} />}
                    {o.avatar}
                    <span className="flex-1 truncate">{o.label}</span>
                    {counts[o.value] != null && (
                      <span className="ml-2 text-[11px] text-zinc-400 tabular-nums">{counts[o.value]}</span>
                    )}
                  </CommandItem>
                );
              })}
            </CommandGroup>
            {selected.size > 0 && (
              <>
                <CommandSeparator />
                <CommandGroup>
                  <CommandItem onSelect={() => onChange(new Set())} className="justify-center text-center">
                    Clear filters
                  </CommandItem>
                </CommandGroup>
              </>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
